var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKitchenPackSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0",
    style: {
      fill: "#D7D7D7"
    },
    d: "M512,431.009H0V80.991h512V431.009z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_",
    style: {
      fill: "#D7D7D7"
    },
    d: "M512,431.009H0V80.991h512V431.009z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B0B0"
    },
    d: "M512,431.009H176.433V80.991H512V431.009z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F6F6F"
    },
    d: "M305.37,356.754H47.496V155.246H305.37L305.37,356.754L305.37,356.754z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444444"
    },
    d: "M305.37,356.754H176.433V155.246H305.37L305.37,356.754L305.37,356.754z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444444"
    },
    d: "M512,431.009H352.866V80.991H512V431.009z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 411.815,
    y: 178.899,
    style: {
      fill: "#F7F7F8"
    },
    width: 40.904,
    height: 33.391
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.815,
    y: 299.709,
    style: {
      fill: "#17778D"
    },
    width: 40.904,
    height: 33.391
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.815,
    y: 239.304,
    style: {
      fill: "#53B8DA"
    },
    width: 40.904,
    height: 33.391
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchenPackSvgrepoCom);
export default __webpack_public_path__ + "static/media/kitchen-pack-svgrepo-com.efc37391879a5455da74f2478190cd75.svg";
export { ForwardRef as ReactComponent };